import React from "react";

export const SelectedAccountContext = React.createContext(null);
